import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsSendToBugTrackerSyslogIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M520.888 798.884l372.92-266.803c6.758-4.823 10.742-12.626 10.762-20.92v-.061a25.809 25.809 0 0 0-10.844-20.972l-372.92-265.083a25.73 25.73 0 0 0-26.747-1.874c-8.55 4.362-13.937 13.23-13.937 22.897v124.754l-334.94-.01c-14.234 0-25.754 11.52-25.754 25.764l.01 230.82c-.01 14.223 11.51 25.754 25.764 25.764h334.909v124.795c0 9.626 5.427 18.463 13.988 22.907 8.571 4.424 18.924 3.666 26.788-1.976z" />
    </g>
  </StyledIcon>
)

CsSendToBugTrackerSyslogIcon.displayName = 'CsSendToBugTrackerSyslogIcon'
